import { defineComponent as _defineComponent } from 'vue';
import { BButton, BButtonGroup, BCol, BRow } from "bootstrap-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SelectTemplate',
    props: {
        selectText: null,
        idPrefix: null,
        templates: null
    },
    emits: ["onSubmit"],
    setup(__props, { emit }) {
        async function handleSubmit(templateId) {
            emit("onSubmit", templateId);
        }
        return { __sfc: true, emit, handleSubmit, BButton, BButtonGroup, BCol, BRow };
    }
});
